// extracted by mini-css-extract-plugin
module.exports = {"banner":"Startups_banner__2To68","btn":"Startups_btn__2zpQf","itemsOnImg":"Startups_itemsOnImg__2Hyyo"};